import { useState, useRef } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';

export default function MouseHoverInfoTooltip({ displayComponent, tooltipComponent, headerComponent, tooltipPlacement }) {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const handleMouseEnter = (event) => {
    setTarget(event.target);
    setShow(true);
  };

  const handleMouseLeave = (event) => {
    setTarget(event.target);
    setShow(false);
  };

  return (
    <span
      ref={ref}
      onLoad={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {displayComponent}

      <Overlay
        show={show}
        target={target}
        placement={tooltipPlacement || "bottom"}
        container={ref}
        containerPadding={20}
        transition={false}
      >
        {({ placement, arrowProps, show: _show, popper, ...props }) => (
          <div
            {...props}
            className={`popover-fade ${show ? 'popover-show' : 'popover-hide'}`}
            style={{ ...props.style }}
          >
            <Popover style={{position:"absolute", right:"-3rem"}}>
              <Popover.Header as="h3">{headerComponent}</Popover.Header>
              <Popover.Body>
                {tooltipComponent}
              </Popover.Body>
            </Popover>
          </div>
        )}
      </Overlay>
    </span>
  );
}
